import { InputCommon, StyledButton, StyledForm } from "@components";
import { ISignUpName } from "@interfaces";
import { IHandleChange, IHandleBlur, IHandleSubmit } from "@interfaces";
import styled from "styled-components";
import { theme } from "@utilities";

interface SignUpNameProps {
    values: ISignUpName;
    handleChange: IHandleChange;
    handleBlur: IHandleBlur;
    handleSubmit: IHandleSubmit;
    isSubmitting: boolean;
}

/**
 * Asked between the address and the password, so the account is never created
 * without a name.
 *
 * The backend mints the points agent's branch identity (e.g.
 * `ft-DWF-guesttraveller`) from whatever name the account holds at creation and
 * never revises it, so a name supplied later does not correct it.
 */
export const SignUpNameComponent = (props: SignUpNameProps) => {
    const { values, handleChange, handleBlur, handleSubmit, isSubmitting } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <StyledWrapper>
                <h2 className="heading">Sign Up</h2>
                <p className="subheading">Tell us who the booking is for.</p>
            </StyledWrapper>
            <InputCommon
                name="first_name"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.first_name}
                label="First name"
                type="text"
            />
            <InputCommon
                name="last_name"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.last_name}
                label="Last name"
                type="text"
            />
            <StyledButton
                $borderRadius={theme.borderRadius.small}
                color={theme.gradients.button}
                disabled={isSubmitting}
                type="submit"
            >
                Continue
            </StyledButton>
        </StyledForm>
    );
};

const StyledWrapper = styled(StyledForm)`
    .heading {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0em;
        text-align: center;
    }

    .subheading {
        margin: 0;
        text-align: center;
        font-size: 14px;
        color: ${theme.colors.gray_1};
    }
`;
